import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'lib/utils';

const AgencyCard = ({ agency, selected = false, onSelect = () => {}, onKeyDown = () => {} }) => (
  <div
    role="radio"
    tabIndex={0}
    aria-checked={selected}
    onClick={onSelect}
    onKeyDown={(event) => {
      if (event.target !== event.currentTarget) return;
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        onSelect();
      } else {
        onKeyDown(event);
      }
    }}
    className={cn(
      'grid w-full min-w-0 grid-cols-[minmax(0,1fr)_18px] items-start gap-x-4 rounded-lg border border-[#dfe6e2] bg-white px-4 py-3 text-left text-sm text-[#202d28] transition-colors hover:border-[#a6bdb0] hover:bg-[#fafcfb] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hajj-primary focus-visible:ring-offset-2',
      selected && 'border-hajj-primary bg-[#f1f8f4] hover:border-hajj-primary hover:bg-[#f1f8f4]'
    )}
  >
    <span className="min-w-0">
      <span className="block break-words font-semibold leading-5">{agency.name}</span>
      {agency.admin?.email && (
        <a
          className="mt-1 block break-all text-[13px] leading-[19px] text-[#6b7772] underline"
          href={`mailto:${agency.admin.email}`}
        >
          {agency.admin.email}
        </a>
      )}
      {(agency.address || agency.phone) && (
        <span className="mt-1 grid min-w-0 grid-cols-1 gap-x-5 gap-y-1 text-[13px] leading-[19px] text-[#6b7772] sm:grid-cols-[minmax(0,1fr)_auto]">
          {agency.address && <span className="min-w-0 break-words">{agency.address}</span>}
          {agency.phone && <span className="break-all text-[#52645a]">{agency.phone}</span>}
        </span>
      )}
    </span>
    <span
      aria-hidden="true"
      className={cn(
        'mt-0.5 flex size-[18px] items-center justify-center rounded-full border border-[#7d8982] bg-white',
        selected && 'border-hajj-primary'
      )}
    >
      {selected && <span className="size-2 rounded-full bg-hajj-primary" />}
    </span>
  </div>
);

AgencyCard.propTypes = {
  agency: PropTypes.shape({}).isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default AgencyCard;
